import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDeleteSvg } from "./IconDeleteSvg.mjs";
const IconDelete = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDeleteSvg, ...iconProps });
};
export {
  IconDelete
};
